export default "__VITE_ASSET__BjREQGaD__"